
/**
 * LAS 33 ENSEÑANZAS (Def 62) — el mapa temático maestro de la Fundación.
 *
 * Faina, 14-sep: la página «33» del menú cuenta lo que el número ha
 * significado en el mundo «y desde ese mismo lugar desplegaremos las 33
 * enseñanzas de la humanidad».
 *
 * 🔒 EL NÚMERO ES 33 Y NO SE MUEVE (Faina, 11-jun: «33 = la edad de Jeshua,
 * número maestro»). Seis familias: A 5 · B 6 · C 6 · D 6 · E 5 · F 5. La fuente
 * de verdad de los códigos es `SCRIPTS/_taxonomia.py` (que tiene el candado
 * `assert len == 33`); aquí viven los mismos códigos con un título corto para
 * el sitio —el largo de la taxonomía no cabe en una tarjeta— y su clave de
 * traducción. Cada canalización publicada lleva 1-3 de estos códigos en
 * `ensenanzas` (regla única, 15-ago), y por eso cada enseñanza puede abrir la
 * Biblioteca filtrada.
 *
 * ⚠️ El título corto se traduce como texto (clave `t33.e.<código>`); el código
 * no se traduce nunca: es el que llevan las piezas.
 */
export const FAMILIAS = [
  { id: 'A', clave: 't33.f.A', codigos: ['A1', 'A2', 'A3', 'A4', 'A5'] },
  { id: 'B', clave: 't33.f.B', codigos: ['B1', 'B2', 'B3', 'B4', 'B5', 'B6'] },
  { id: 'C', clave: 't33.f.C', codigos: ['C1', 'C2', 'C3', 'C4', 'C5', 'C6'] },
  { id: 'D', clave: 't33.f.D', codigos: ['D1', 'D2', 'D3', 'D4', 'D5', 'D6'] },
  { id: 'E', clave: 't33.f.E', codigos: ['E1', 'E2', 'E3', 'E4', 'E5'] },
  { id: 'F', clave: 't33.f.F', codigos: ['F1', 'F2', 'F3', 'F4', 'F5'] }
];

export const CODIGOS_33 = FAMILIAS.flatMap((f) => f.codigos);

export const countByTeaching = (items) => {
  const counts = {};
  items.forEach((item) => {
    (item.ensenanzas || []).forEach((code) => { counts[code] = (counts[code] || 0) + 1; });
  });
  return counts;
};

export const teachingOptions = (items) => {
  const counts = countByTeaching(items);
  return CODIGOS_33.map((code) => ({
    id: code,
    clave: `t33.e.${code}`,
    texto: code,
    n: counts[code] || 0
  }));
};
